"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINKEDIN = exports.IG_LANDSCAPE = exports.FB_LANDSCAPE = exports.FOUR_FIVE = exports.TWO_ONE = void 0;
var TWO_ONE = [2, 1];
exports.TWO_ONE = TWO_ONE;
var FOUR_FIVE = [4, 5];
exports.FOUR_FIVE = FOUR_FIVE;
var FB_LANDSCAPE = [300, 175];
exports.FB_LANDSCAPE = FB_LANDSCAPE;
var IG_LANDSCAPE = [1.91, 1];
exports.IG_LANDSCAPE = IG_LANDSCAPE;
var LINKEDIN = [1.91, 1];
exports.LINKEDIN = LINKEDIN;